<template>
	<div class="row">
		<div class="col-md-12">
			<div class="form-group">
				<label>Resource Type</label>
				<multiselect
					name="link_type"
					:options="optionsForLinkType.map(x => x.id)"
					label="name"
					v-model="type.value"
					:allow-empty="false"
				>
					<template slot="singleLabel" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
					<template slot="option" slot-scope="props">
						<img class="link-type-icon" :src="require(`@/csmworkflow/img/${getOptionObject(props.option).icon}`)" alt="icon">
						<span class="link-type-title">{{ getOptionObject(props.option).name }}</span>
					</template>
				</multiselect>
			</div>
		</div>
		<div class="col-md-12" v-show="!isFile">
			<div class="form-group">
				<label>URL</label>
				<div class="input-group">
					<input type="text" v-model="url.value" class="form-control test" v-on:keyup.enter="saveFn" ref="focusThis"/>
					<div class="input-group-append">
						<button @click="copyUrl" id="copy-url-btn" class="btn btn-text btn-copy" type="button" data-dismiss="modal"><i :class="copyIcon"></i></button>
						<b-tooltip target="copy-url-btn" triggers="hover" noninteractive>{{copyTooltipText}}</b-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-12" v-show="error">
			<div class="alert alert-danger">URL is invalid</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Label</label>
				<input type="text" v-model="label.value" class="form-control"  v-on:keyup.enter="saveFn" :disabled="isFile" />
			</div>
		</div>
		<div class="col-md-12">
			<div class="form-group">
				<label>Notes</label>
				<textarea class="form-control" v-model="notes.value"></textarea>
			</div>
		</div>

		<div class="row col-md-12">
			<div class="col">
				<button class="btn btn-primary" type="button" @click="saveFn" data-dismiss="modal">Save</button>
			</div>
			<div class="col text-right">
				<button class="btn btn-text" type="button" @click="removeLink" data-dismiss="modal">Delete</button>
			</div>
		</div>
		<b-modal v-model="showRemoveLink" type="warn" title="Confirm Deletion" @ok="removeFn" ok-title="Yes, Delete">
			<p>Are you sure you want to delete this resource/link?</p>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Autolinker from 'autolinker';

export default {
	props: {
		linkUrl:Object,
		linkLabel:Object,
		linkNotes:Object,
		linkType:Object,
		isFile:Boolean
	},
	data() {
		return {
			url: {},
			label: {},
			notes: {},
			type: {},
			error: false,
			filteredStates: [],
			showRemoveLink: false,
			copySuccessTimeout: null,
			copyIcon: 'far fa-copy',
			copyTooltipText: 'Copy URL',
		};
	},
	computed: {
		...mapGetters(["socialCampaignDetail", "allCustomFields"]),
		optionsForLinkType() {
			const linkTypeField = this.allCustomFields.find(x => x.id == 37);
			return JSON.parse(linkTypeField.value_set);
		},
	},
	methods: {
		focusMyElement() {
			if (this.$refs.focusThis) {
				this.$refs.focusThis.focus();
			}
		},
		saveFn() {
			let that = this;
			if(
				this.url.value === this.linkUrl.value &&
				this.label.value === this.linkLabel.value &&
				this.notes.value === this.linkNotes.value &&
				this.type.value === this.linkType.value
			){
				console.log("values are the same");
				that.$bvModal.hide('editLinkModal');
				return;
			}
			
			console.log("values have changed");

			that.error = false;

			if(!that.url.value) {
				console.log("url is empty");
				that.error = true;
				return;
			}
			let url = that.url.value.trim();
			let matches = Autolinker.parse(url, {
				urls: true
			});
			if (matches.length > 0) {
				console.log("matches found");
				if (matches[0].type == "url") {
					url = matches[0].getUrl();
				} else {
					that.error = true;
				}
			} else {
				console.log("no matches found");
				that.error = true;
			}
			if (!that.error) {
				this.$store.dispatch("updateSocialCampaignResourceUrl", {
					linkUrl:this.url,
					linkLabel:this.label,
					linkNotes:this.notes,
					linkType:this.type
				}).then(() => {
					that.$bvModal.hide('editLinkModal')
				});
			}
		},
		removeLink() {
			this.showRemoveLink = true;
		},
		removeFn() {
			let that = this;
			if (this.linkUrl.id) {
				this.$store
					.dispatch("removeSocialCampaignResourceUrl", {linkUrl: this.linkUrl.scfv_id})
					.then(() => {
						that.$bvModal.hide('editLinkModal')
					});


			} else {
				that.$bvModal.hide('editLinkModal')
			}
		},
		getOptionObject(id) {
			return this.optionsForLinkType.find(x => x.id == id);
		},

		async copyUrl() {
			clearTimeout(this.copySuccessTimeout);
			const navPer = await navigator.permissions.query({name: "clipboard-write"});
			if (navPer.state == "granted" || navPer.state == "prompt") {
				try {
					await navigator.clipboard.writeText(this.linkUrl.value);
				} catch {
					console.error("clipboard API error. Cannot copy to clipboard.");
					this.legacyCopyMethod();
				}
			} else {
				this.legacyCopyMethod();
			}


			this.copyIcon = "fas fa-check";
			this.copyTooltipText = "Copied!";
			this.copySuccessTimeout = setTimeout(() => {
				this.copyIcon = "far fa-copy";
				this.copyTooltipText = "Copy URL";
			}, 2000);
		},
		legacyCopyMethod() {
			this.$refs.focusThis.select();
			document.execCommand("copy");
			this.$refs.focusThis.blur();
		},
	},
	created() {
		this.url = Object.assign(this.url, this.linkUrl);
		this.label = Object.assign(this.label, this.linkLabel);
		this.notes = Object.assign(this.notes, this.linkNotes);
		this.type = Object.assign(this.type, this.linkType);
	}
};
</script>

<style>
</style>